import React, {useState}   from "react";
import { Button } from 'reactstrap';

import './EditableCell.css';

export const  EditableCell = ({ 
                readOnly = false,
                defaultValue,
                defaultEditable = false,
                textAlign,
                updateValue,
                contentType = "text",
                maxLength,
                options,   
                type
                 }) => { 


    const [isEditable, setIsEditable] = useState(defaultEditable);
    const [editedVal, setEditedVal] = useState();

    const confirmOption =  ( val  ) => {

        val && updateValue(val) ;
        // El delay es para que se vea mejor. TODO: Mejorar esto
        setTimeout(function() {  setIsEditable( false ); }, 500)

    }

    const endEditAndSave =  (  ) => {
        updateValue && updateValue(editedVal) ;
        // El delay es para que se vea mejor. TODO: Mejorar esto
        setTimeout(function() {  setIsEditable( false ); }, 500)

    }
    const startEdit =  (  ) => {
        setIsEditable( true ) ;
    }

    if (!isEditable || readOnly) {
        return(
            <div  className={readOnly?"display-text":"display-text display-text-editable"}
                    style={{textAlign: textAlign?textAlign:'', cursor: readOnly?'default':'' }}
                    onClick={() => { startEdit() }}
           > 
           {
                type === "OPT"?
                    defaultValue.opt_value?defaultValue.opt_value:<>&nbsp;</>
                :
                defaultValue?
                    (maxLength && defaultValue.length > maxLength ? 
                        defaultValue.substring(0,maxLength).concat(' ...') 
                        : defaultValue )
                    :<>&nbsp;</>
            }
        </div>
        )
    }
    else if ( type === "NUM" ) {
            return (
                <div>
                    <input 
                        className="edit-input" 
                        style={{textAlign: textAlign?textAlign:'' }}
                        autoFocus
                        type={contentType}
                        defaultValue={defaultValue}
                        onBlur={() => {endEditAndSave() }}
                        onFocus={(event) => setEditedVal(event.target.value)}
                        onKeyUp={(event) => {
                            if (event.key === 'Enter' || event.keyCode === 13) {
                                endEditAndSave();
                            }
                        }}
                        onChange={(event) => {
                                        setEditedVal(event.target.value);
                                        if (event.key === 'Enter' || event.keyCode === 13) {
                                            endEditAndSave();
                                        }
                                    }
                                }
                        />

                </div>
            )
        }

    else if ( type === "TXT" ) {
            return (
                <div className="div-edit-textarea">
                    <textarea 
                        className="edit-textarea" 
                        rows={4}
                        style={{textAlign: textAlign?textAlign:'' }}
                        autoFocus
                        type={contentType}
                        defaultValue={defaultValue}
                        // onBlur={() => {endEdit() }}
                        onFocus={(event) => setEditedVal(event.target.value)}
                        onChange={(event) => setEditedVal(event.target.value)}
                        />
                    <Button color="danger" size="sm"
                      onClick={() => setIsEditable( false ) } 
                      >
                      <span className="btn-label"> <i className="fa fa-ban"></i> </span> Cancelar
                    </Button>
                    <Button color="info" size="sm"
                       onClick={() => endEditAndSave() } 
                      >
                      <span className="btn-label"> <i className="fa fa-floppy-o"></i> </span> Grabar
                    </Button>
                    

                </div>
            )
        }
    // TODO:
    else if ( type === "OPT" ) {
            
            return (
                <div>
                    <select name="select"
                         className="edit-select" 
                         style={{textAlign: textAlign?textAlign:'' }}
                         onBlur={() => {confirmOption() }}
                         onFocus={(event) =>  setEditedVal(event.target.value)}
                         onChange={(event) => confirmOption(event.target.value)}

                         >
                        {!defaultValue.eval_type_opt_id && <option value=''>----------</option>}
                        { options.map( opt => {
                            return <option 
                                        value={opt.value}
                                        selected={opt.value===defaultValue.eval_type_opt_id}
                                        >{opt.label}</option>
                        })}
                    </select>
                  
                  
                   {/* <input 
                       
                        
                        autoFocus
                        type={contentType}
                        defaultValue={defaultValue}
                        
                        onFocus={(event) => setEditedVal(event.target.value)}
                        onKeyUp={(event) => {
                            if (event.key === 'Enter' || event.keyCode === 13) {
                                endEditAndSave();
                            }
                        }}
                        onChange={(event) => {
                                        setEditedVal(event.target.value);
                                        if (event.key === 'Enter' || event.keyCode === 13) {
                                            endEditAndSave();
                                        }
                                    }
                                }
                        /> */}

                </div>
            )
        }
}


